import Brieffeld from '@/types/Brieffeld';

export default class Briefart {
    public briefart_id: number | null = null;
    public briefart: string | null = null;
    public gueltig: string | null = 'j';
    public brieffelder: Brieffeld[] = [];

    public static readonly MAX_FIELDS = 6;

    constructor(briefart?: Partial<Briefart>) {
        Object.assign(this, briefart);

        this.brieffelder = (new Array(Briefart.MAX_FIELDS))
            .fill(undefined)
            .map((_, index) => {
                const feldnummer = index + 1;
                return this.brieffelder.find((brieffeld) => brieffeld.feldnummer === feldnummer) ??
                    new Brieffeld(feldnummer);
            });
    }
}
